import { schema } from "normalizr";
import Resource from "./resource";
import { expertisesTypes } from "../types";

const expertisesSchema = new schema.Entity("expertises");

export default new Resource("/expertises", expertisesTypes, expertisesSchema);
